import * as React from 'react'
import { FC } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { ISalesFunnelCard } from '@user/store/salesFunnelSummary/typings'
import { SalesFunnelStageStats } from './SalesFunnelStageStats'

import Grid from '@mui/material/Grid'

interface Props {
  funnelCard: ISalesFunnelCard
  handleClose: () => void
}

export const SalesFunnelCardDrawer: FC<Props> = (props) => {
  const { funnelCard, handleClose } = props
  const { stageDetails } = funnelCard

  return (
    <Grid container spacing={4} direction="column">
      {!!stageDetails?.leads && (
        <Grid item>
          <SalesFunnelStageStats
            entityType={ENTITY_TYPES.Lead}
            funnelCard={funnelCard}
            handleClose={handleClose}
          />
        </Grid>
      )}

      {!!stageDetails?.opportunities && (
        <Grid item>
          <SalesFunnelStageStats
            entityType={ENTITY_TYPES.Opportunity}
            funnelCard={funnelCard}
            handleClose={handleClose}
          />
        </Grid>
      )}
    </Grid>
  )
}

SalesFunnelCardDrawer.displayName = 'SalesFunnelCardDrawer'
